export default __webpack_public_path__ + "static/body_systems-235cbca19b5b554d88980531ca3b054c.jpg";